module.exports = __webpack_public_path__ + "img/profile_pic_girl.5bb17341.png";